// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  ecockpitUrl: 'https://dev-master.myefirm.de/',
  dashboardUrl: 'https://dev-elearning-dashboard.myefirm.de/',

  firstStepsAppId: 728,
  readingSampleLibraryId: 729,
  readingSampleLibraryOverviewId: 730,
  readingSampleElearningId: 211,

  person_name: '',
  username: '',
  birthdate: '',
  email: '',
  password: '',

  // Online check
  online_check_interval: 5000, // in ms
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
